import React, { memo } from 'react';
import { Chips } from '../ui/Chips';
import { AdditionalParameter } from '../../hooks/useAdditionalParameters';
import { AdditionalParametersWrapper } from './styled';

const ICON_SIZE = 26;

export interface AdditionalParametersListProps {
  parameters: AdditionalParameter[];
  cypress: string;
  selectedIds?: string[];
  onToggle?: (id: string) => void;
}

const AdditionalParametersListComponent: React.FC<
  AdditionalParametersListProps
> = ({ parameters, cypress, selectedIds, onToggle }) => (
  <AdditionalParametersWrapper data-cy={cypress}>
    {parameters.map(parameter => (
      <Chips
        key={parameter.id}
        text={parameter.name}
        value={parameter.id}
        icon={parameter.iconUrl}
        iconSize={ICON_SIZE}
        type="checkbox"
        hasCustomOnChange
        storedValue={selectedIds}
        onClick={onToggle ? () => onToggle(parameter.id) : undefined}
        cypress={`${cypress}-item-${parameter.id}`}
        isTextPadding={false}
      />
    ))}
  </AdditionalParametersWrapper>
);

export const AdditionalParametersList = memo(AdditionalParametersListComponent);
